import {
    get2,
    get,
    post,
    url,
    fetch,
    post2,
    get3
} from "../http"

class Teacher {
    @url("banner/list")
    @get
    getBanners() {}

    @url("cnu/common/queryLabelList")
    @get
    getLabes() {}

    @url("news/list")
    @get
    getNews() {}






    // 底部链接
    @url("info/bottom")
    @get
    getLinks() {}

    //公共列表请求
    @url("/cnu/common/queryKeyList")
    @get
    queryKeyList() {}

    // 公共列表详情请求
    @url("/cnu/common/queryListByKey")
    @get
    queryListByKey() {}

    // 查询课程中台筛选部分
    @url("/cnu/common/queryLabelList")
    @get
    queryLabelList() {}

    // 登录
    // @url("/yun/auth/user/login")
    @url("/s/auth/user/login")
    @post
    login() {}

    // // 登出
    // @url("/s/auth/user/logout")
    // @get
    // logout() {}

    // 手机号登录
    // @url("/yun/auth/user/loginByPhone")
    @url("/s/auth/user/loginByPhone")
    @post
    loginByPhone() {}

    // 验证手机验证码
    // @url("/yun/auth/user/phone/send_code")
    @url("/s/auth/user/phone/send_code")
    @post
    getVerifyCode() {}

    // 验证手机验证码
    // @url("/yun/auth/user/phone/check")
    @url("/s/auth/user/phone/check")
    @post
    checkCode() {}

    // 查询个人信息
    // @url("/yun/auth/user/info")
    @url("/s/auth/user/info")
    @get
    userInfo() {}

    // 查询课程列表
    // @url("/yun/course/teach/courseCloud/openList")
    @url("/s/course/teach/courseCloud/openList")
    @get
    getCourseList() {}

    // 查询课程详情
    // @url("/yun/course/teach/courseCloud/openDetail")
    @url("/s/course/teach/courseCloud/openDetail")
    @get
    getCourseDetail() {}

    // 查询课节列表
    // @url("/yun/course/teach/courseCloud/openDetail")
    @url("/s/course/teach/courseCloud/openLesson")
    @get
    getCourseLesson() {}

    // 查询视频课节信息
    // @url("/yun/course/teach/courseCloud/openDetail")
    @url("/s/course/teach/lesson/getLessonById/")
    @fetch
    getLessonInfo() {}

    // 查询课程视频
    @url("/s/course/teach/lesson/getLessonVideoUrl/")
    @fetch
    getLessonVideoUrl() {}

    //教师列表
    @url("tea/list")
    @get
    gettealist() {}

    //教师详情
    @url("tea/one")
    @get
    getteadetail() {}

    //新闻列表
    @url("/news/list") //clazz 1.头条新闻 2.综合新闻 3.专题新闻
    @get
    GetNewsList() {}

    //新闻详情
    @url("/news/one") //
    @get
    GetNewsDetail() {}

    //最新推荐
    @url("/news/recommend") //
    @get
    GetNewsRecommend() {}

    //上下条信息
    @url("/news/near")
    @get
    GetNear() {}

    // 获取内蒙项目的课程表
    @url("/open/jm/schedule")
    @get2
    GetTimetable() {}

    // 首页-优质课程
    @url("/open/jm/listBoutiqueJm")
    @get2
    GetSuperiorCourse() {}

    // 云端学校-课程
    @url("/open/jm/listCourseJm")
    @get2
    GetCloudCourse() {}

    // 云端学校-课程表某一天的数据
    @url("/open/jm/scheduleOne")
    @get2
    GetCloudCourseByDay(){}

    // 研学基地列表
    @url("/open/studyBase/list")
    @get2
    GetAddress(){}

    // 研学基地详情
    @url("/open/studyBase/one")
    @get2
    GetAddressDetail(){}

    // 研学基地留言
    @url("/open/studyBase/leaveMassage")
    @post2
    Message(){}

    // 研训成果(瀑布流)
    @url("/open/jmMatch/getMatchAchievement")
    @get2
    Result(){}

    // 驼铃杯
    @url('/open/jmMatch/getLastMatchInfo')
    @get2
    cupInfo(){}

    // 驼铃杯课程列表
    @url('/open/jmMatchCourse/list')
    @get2
    listActivity(){}


}

export default new Teacher()